import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable, throwError} from "rxjs";
import {catchError, map} from "rxjs/operators";
import {ChannelProfile} from "../interfaces";

@Injectable({providedIn: 'root'})
export class ChannelService {

  constructor(private http: HttpClient){
  }

  /*

 */

  getOwn():Observable<ChannelProfile>{
    return this.http.get<ChannelProfile>(`/api/channel/get`)
  } 

 getByUrl(url:string):Observable<ChannelProfile>{
    return this.http.get<ChannelProfile>(`/api/channel/view/get-by-url/${url}`)
  } 


  checkUrlAvailable(url: String):Observable<boolean>{
    return this.http.post<any>(`/api/channel/check-url-available`,{url}).pipe(
		map((r)=>{return r.available})
	)
  } 

 
  update(  
     channel: ChannelProfile,   uploadCover: any,   uploadAvatar: any,
    uploadThumb: any,  deleteCover: boolean,  deleteAvatar: boolean,  deleteThumb: boolean
    ): Observable<ChannelProfile>{

      const formData = new FormData()
      
      if(channel.title){  formData.append('title', channel.title) }
      if(channel.site){  formData.append('site', channel.site) }
      if(channel.description){  formData.append('description', channel.description) }
      if(channel.url){   formData.append('url', channel.url) }
      if(channel.soc_facebook){  formData.append('soc_facebook', channel.soc_facebook)  }
      if(channel.soc_instagram){  formData.append('soc_instagram', channel.soc_instagram) }
      if(channel.soc_vk){  formData.append('soc_vk', channel.soc_vk) }
      if(channel.soc_twitter){  formData.append('soc_twitter', channel.soc_twitter)  }
      if(channel.msg_whatsapp){  formData.append('msg_whatsapp', channel.msg_whatsapp)  }
      if(channel.msg_telegram){  formData.append('msg_telegram', channel.msg_telegram) }
      if(channel.msg_viber){  formData.append('msg_viber', channel.msg_viber) }
      if(uploadCover) {  formData.append('cover_image',uploadCover, uploadCover.name) }
      if(uploadAvatar) {  formData.append('avatar_image',uploadAvatar, uploadAvatar.name) }
      if(uploadThumb) {  formData.append('thumb_image',uploadThumb, uploadThumb.name) }
      if(deleteCover) {  formData.append('deleteCover', 'true') }
      if(deleteAvatar) {  formData.append('deleteAvatar', 'true') }
      if(deleteThumb) {  formData.append('deleteThumb', 'true') }

      return this.http.patch<ChannelProfile>(`/api/channel/update`,formData)
  }


    viewFetchAll(params:any = {}):Observable<ChannelProfile[]>{
    return this.http.post<ChannelProfile[]>('/api/channel/view/get-all', params)
  }
  

  
    viewChanelsSearch(text:string):Observable<any>{
    return this.http.post<any>('/api/channel/view/search-channels', {text})
  }
  

    viewChannelsSearchInner(url, text):Observable<any> { 
 
	const obj : any = {};

	obj.url = url;

	if(text){
	  obj.text =  text;
	}

	
    return this.http.post<any>('/api/channel/view/search-channel-inner', obj)
  }
  

}
